// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3CRvv","buttons":"Footer_buttons__YaTFQ"};